// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "public/94f20a0ac34737d7f132c980e4a1a1dc5b6213c9/" + (chunkId === 179 ? "main" : chunkId) + ".css";
};